import './App.css';
import Game from './components/Game'
function App() {
  return (
    <div className="App">
      <h1>Wordle</h1>
      <Game />
    </div>
  );
}

export default App;
